import AES from 'crypto-js/aes'
import Utf8 from 'crypto-js/enc-utf8'
import Messages from './Messages'
import { HttpService, ServiceEndpoints } from '@/config/NextImport'
import Cookies from 'js-cookie'

export const Pagesize = 40
export const DiamondPageSize = 40

export const isJSON = (string: any) => {
  try {
    JSON.parse(string)
  } catch (e) {
    return false
  }
  return true
}

export const encryptData = (data: any) => {
  if (process.env.NEXT_PUBLIC_NODE_ENV === 'development') {
    return data
  } else {
    return AES.encrypt(data, 'Please#dont@share&me')
  }
}

export const decryptData = (data: any) => {
  if (data === '' || data === '[]' || data === undefined) return null
  else if (process.env.NEXT_PUBLIC_NODE_ENV === 'development' && isJSON(data)) {
    return data
  } else {
    try {
      const bytes = AES.decrypt(data, 'Please#dont@share&me')
      const decryptData = bytes.toString(Utf8)
      if (decryptData) {
        return decryptData
      } else {
        return data
      }
    } catch (e) {
      return data
    }
  }
}

export const getSanitizedUrl = (url: string): string => {
  const urlArray = url.split('/')
  const lastSlug = urlArray[urlArray.length - 1]
  return lastSlug?.includes('-sku-') ? urlArray.slice(0, -1).join('/') : url
}

export const DateFormat = (value: string | number | Date | null | undefined): string => {
  if (!value) return ''

  const format = process.env.NEXT_PUBLIC_DATE_FORMAT || 'DD/MM/YYYY, hh:mm A'
  const d = new Date(value)

  if (isNaN(d.getTime())) return '' // invalid date guard

  const pad = (n: number): string => String(n).padStart(2, '0')

  const map: Record<string, string> = {
    YYYY: String(d.getFullYear()),
    MM: pad(d.getMonth() + 1),
    DD: pad(d.getDate()),
    hh: pad(((d.getHours() + 11) % 12) + 1), // 12-hour
    HH: pad(d.getHours()), // 24-hour
    mm: pad(d.getMinutes()),
    A: d.getHours() >= 12 ? 'PM' : 'AM'
  }

  let result = format

  // Replace longer keys first (prevents partial replacement issues)
  const tokens = Object.keys(map).sort((a, b) => b.length - a.length)

  tokens.forEach((key) => {
    result = result.replace(new RegExp(key, 'g'), map[key])
  })

  return result
}
export const GetPathname = () => {
  return window.location.pathname.replace(/\/$/, '')
}

export const GetFullURL = () => {
  return window.location.pathname + window.location.search
}

export const setImagePath = (imagePath: string) => {
  return process.env.NEXT_PUBLIC_S3_BUCKET_URL + imagePath
}

export const GetRecentBuilder = () => {
  let getStorage = localStorage.getItem(Messages.last_recent_product)
  try {
    if (getStorage !== null && getStorage !== 'null') {
      getStorage = JSON.parse(getStorage)
    } else return []
  } catch (error) {
    return []
  }
  return getStorage
}

export const SetRecentBuilder = async (product: any) => {
  const recentData: any = GetRecentBuilder()
  const IsExists = recentData.filter((x: any) => x.sku === product.sku)
  if (IsExists.length === 0) recentData.push(product)
  localStorage[Messages.last_recent_product] = encryptData(JSON.stringify(recentData))
}

export const isNullorEmpty = (value: any) => {
  if (value === undefined || value === null || value === '') return true
  else return false
}

export function toTitleCase(str: string) {
  if (!str || typeof str !== 'string') return '' // handles null, undefined, and non-string inputs

  return str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  )
}

export const GetJSON = (str: string) => {
  if (str === undefined || str === '') return null
  else if (typeof str === 'string') return JSON.parse(str)
  else return str
}
export const getCurrencies = () => {
  return {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    CAD: 'C$',
    AUD: 'A$',
    CHF: '₣',
    BHD: 'د.ب',
    INR: '₹'
  }
}
export const chunk = (array: any, chunkSize: any) => {
  const size = Math.ceil(array.length / chunkSize)
  const chunks = new Array(size).fill(0)
  return chunks.map((_, index) => {
    const start = index * chunkSize
    const end = (index + 1) * chunkSize
    return array.slice(start, end)
  })
}

export const placeOrder = (
  response: any,
  orderTransactionId: any,
  cartProducts: any,
  user: any,
  promoCode: string,
  paymentMethod: string
) => {
  let customerId = ''
  if (user !== undefined && user !== null) customerId = user?.id
  let billingAddress: any = {}
  let shippingAddress: any = {}
  let paymentResponse: any = {}
  let subTotal = cartProducts.order_total
  let orderTotal = cartProducts.order_total
  let taxAmount = cartProducts.order_vat
  if (paymentMethod === 'credit_card') {
    paymentResponse = response.result.session
    subTotal = Math.round(paymentResponse.amount_subtotal / 100)
    orderTotal = Math.round(paymentResponse.amount_total / 100)
    taxAmount = Math.round(paymentResponse.total_details.amount_tax / 100)
    const customerData = response.result.customer
    const customerAddress = customerData.address
    const orderShippingAddress = paymentResponse.shipping
    const name = customerData.name.split(' ')
    billingAddress = {
      firstname: name[0],
      lastname: name[1],
      country: customerAddress.country,
      city: customerAddress.city,
      line1: customerAddress.line1,
      line2: customerAddress.line2,
      postal_code: customerAddress.postal_code,
      phone: customerData.phone,
      email: customerData.email
    }
    const shippingName = orderShippingAddress.name.split(' ')
    shippingAddress = {
      firstname: shippingName[0],
      lastname: shippingName[1],
      country: orderShippingAddress.address.country,
      city: orderShippingAddress.address.city,
      line1: orderShippingAddress.address.line1,
      line2: orderShippingAddress.address.line2,
      postal_code: orderShippingAddress.address.postal_code,
      phone: customerData.phone != null ? customerData.phone : '',
      email: customerData.email
    }
  } else {
    paymentResponse = response
    const name = response.payerName.split(' ')
    const address = response.paymentMethod.billing_details.address
    billingAddress = {
      firstname: name[0] !== undefined ? name[0] : '',
      lastname: name[1] !== undefined ? name[1] : '',
      country: address.country,
      city: address.city,
      state: address.state,
      line1: address.line1,
      line2: address.line2,
      postal_code: address.postal_code,
      phone: response.paymentMethod.billing_details.phone ?? '',
      email: response.paymentMethod.billing_details.email ?? ''
    }
    shippingAddress = billingAddress
  }

  if (cartProducts != null && cartProducts.products?.length > 0) {
    const taxPercentage = Math.round((taxAmount / subTotal) * 100)
    const param = {
      customer_id: customerId,
      email: billingAddress.email,
      billing_fname: billingAddress.firstname,
      billing_lname: billingAddress.lastname,
      billing_country: billingAddress.country,
      billing_city: billingAddress.city,
      billing_state: billingAddress.state,
      billing_street_address1: billingAddress.line1,
      billing_street_address2: billingAddress.line2,
      billing_county: '',
      billing_postcode: billingAddress.postal_code,
      billing_phone: billingAddress.phone,
      billing_email_address: billingAddress.email,
      shipping_fname: shippingAddress.firstname,
      shipping_lname: shippingAddress.lastname,
      shipping_country: shippingAddress.country,
      shipping_city: shippingAddress.city,
      shipping_state: shippingAddress.state,
      shipping_street_address1: shippingAddress.line1,
      shipping_street_address2: shippingAddress.line2,
      shipping_county: '',
      shipping_postcode: shippingAddress.postal_code,
      shipping_phone: shippingAddress.phone,
      shipping_email_address: shippingAddress.email,
      special_offer_status: '',
      delivery_method: '',
      payment_method: paymentMethod,
      qty: cartProducts.products.length,
      order_total: orderTotal,
      coupon_code: promoCode,
      discount_per: 0,
      discount_amount: cartProducts.order_discount,
      shipping_amount: 0,
      // tax_amount: CartProducts.order_vat,
      tax_percentage: taxPercentage,
      tax_amount: taxAmount,
      final_price: orderTotal,
      products: cartProducts.products,
      stripe_token: '',
      order_status: 'INPROCESS',
      payment_response: paymentResponse,
      transaction_id: orderTransactionId
    }
    return new Promise((resolve) => {
      HttpService.postApi(ServiceEndpoints.placeOrder, param, false).then((response) => {
        resolve(response)
      })
    })
  }
}

export const onLoginSuccess = (user: any) => {
  const appState = {
    isLoggedIn: true,
    user,
    session_token: user.token
  }

  const encryptedState = AES.encrypt(JSON.stringify(appState), 'Please#dont@share&me').toString()

  Cookies.set(Messages.WebsiteAppState, encryptedState, {
    expires: 30, // Note: js-cookie 'expires' expects days, so 30 days is correct for a month
    path: '/',
    secure: process.env.NEXT_PUBLIC_NODE_ENV === 'production',
    sameSite: 'lax'
  })

  // Store token as reference
  let rendomnumber = ''
  const characters = Messages.Tokenchar
  const charactersLength = characters.length
  for (let i = 0; i < 100; i++) {
    rendomnumber += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  let ciphertext: any = AES.encrypt(rendomnumber, Messages.Secretkey)

  localStorage.setItem(Messages.grecaptcha, ciphertext)

  ciphertext = AES.encrypt(appState.session_token, rendomnumber)
  localStorage.setItem(Messages.pageId, ciphertext)
}

export const storeLinkClickData = async (productSku: string, productUrl: string) => {
  const param = {
    sku: productSku,
    url: productUrl
  }
  await HttpService.postApi(ServiceEndpoints.setLinkClick, param, false)
}

export const setLinkClick = async (productSku: string, productUrl: string) => {
  if (
    Cookies.get(Messages.PageVisitStatus) === undefined ||
    Cookies.get(Messages.PageVisitStatus) === null
  ) {
    await storeLinkClickData(productSku, productUrl)
    const pageVisitData = [{ sku: productSku, url: productUrl, created_at: new Date() }]
    
    Cookies.set(Messages.PageVisitStatus, encodeURIComponent(JSON.stringify(pageVisitData)), {
      path: '/',
      secure: true,
      sameSite: 'lax'
    })
  } else {
    const pageVisitData = JSON.parse(decodeURIComponent(Cookies.get(Messages.PageVisitStatus)!))
    const filteredData = pageVisitData.filter((x: any) => x.sku === productSku)
    const index = pageVisitData.findIndex((x: any) => x.sku === productSku)
    if (filteredData.length > 0) {
      const newDate = new Date(new Date(filteredData[0].created_at).getTime() + 60 * 60 * 24 * 1000)
      if (new Date() > newDate) {
        storeLinkClickData(productSku, productUrl)
        pageVisitData[index].created_at = new Date()
      }
    } else {
      pageVisitData.push({ sku: productSku, url: productUrl, created_at: new Date() })
      storeLinkClickData(productSku, productUrl)
    }

    Cookies.set(Messages.PageVisitStatus, encodeURIComponent(JSON.stringify(pageVisitData)), {
      path: '/',
      secure: true,
      sameSite: 'lax'
    })
  }
}
export const toUKTime = (dateStr: string) => {
  const date = new Date(dateStr);

  // remove timezone offset effect
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes()
  );
}